import { styled } from '@mui/material/styles';
import { MuiGrid } from '../../../../../modules/material';
import { MarginVariants, SectionProps } from './index';

const getMarginValues = (variant: SectionProps['marginVariant']) => {
  switch (variant) {
    case MarginVariants.default:
      return 'var(--payment-layout-section-margin)';
    case MarginVariants.small:
      return 'var(--payment-layout-section-margin-small)';
    case MarginVariants.extraSmall:
      return 'var(--payment-layout-section-margin-extra-small)';
  }
};

const styledSectionOptions = {
  shouldForwardProp: (prop: string) => !['marginVariant'].includes(prop),
};

interface StyledSectionProps {
  marginVariant?: SectionProps['marginVariant'];
}

export const StyledSection = styled(
  'section',
  styledSectionOptions,
)<StyledSectionProps>(({ marginVariant }) => {
  return {
    '&:not(:last-child)': {
      ...(marginVariant && {
        marginBottom: getMarginValues(marginVariant),
      }),
    },
  };
});

const styledMainContentOptions = {
  shouldForwardProp: (prop: string) =>
    !['rightColumn', 'marginVariant'].includes(prop),
};

interface StyledMainContentProps {
  rightColumn?: SectionProps['rightColumn'];
  marginVariant?: SectionProps['marginVariant'];
}

export const StyledMainContent = styled(
  MuiGrid,
  styledMainContentOptions,
)<StyledMainContentProps>(({ rightColumn, marginVariant, theme }) => {
  const isMargin = rightColumn && marginVariant;

  return {
    [theme.breakpoints.down('md')]: {
      ...(isMargin && {
        marginBottom: getMarginValues(marginVariant),
      }),
    },
  };
});
